import React, { FC } from 'react';
import Dialog from '@mui/material/Dialog';
import Slide from '@mui/material/Slide';
import { TransitionProps } from '@mui/material/transitions';
import { ChevronLeft, CloseIcon, MenuIcon } from '@/components/icons';
import { useTranslations } from 'next-intl';
import { Divider } from '@mui/material';
import useNoScroll from '@/hooks/useNoScroll';
import useWrapperLock from '@/hooks/useWrapperLock';

interface FullScreenDialogProps {
  open: boolean;
  handleClose: () => void;
  hasBackBtn?: boolean;
  hasMenu?: boolean;
  children: React.ReactNode;
  title?: string;
  subTitle?: string;
  hasClearBtn?: boolean;
  handleClear?: () => void;
  hasApplyBtn?: boolean;
  handleApply?: () => void;
  handleOpenMenu?: () => void;
  hasBorder?: boolean;
  CustomClass?:string;
}

const Transition = React.forwardRef(function Transition(
  props: TransitionProps & {
    children: React.ReactElement<unknown>;
  },
  ref: React.Ref<unknown>,
) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const FullScreenDialog: FC<FullScreenDialogProps> = ({
  open,
  handleClose,
  hasBackBtn = false,
  hasMenu = false,
  children,
  title,
  subTitle,
  hasClearBtn,
  handleClear,
  hasApplyBtn = false,
  handleApply,
  handleOpenMenu,
  hasBorder = false,
  CustomClass
}) => {
  const t = useTranslations();
  useNoScroll(open);
   useWrapperLock(open);
  return (

    <Dialog
      fullScreen
      open={open}
      onClose={handleClose}
      TransitionComponent={Transition}
      className=''
    >
      <div className='flex flex-col gap-6 h-full !min-h-fit bg-[#F7FAFD] max-w-screen-sm:pt-20'>
        <div className={`flex flex-col ${hasBorder ? "gap-6" : "gap-10"}`}>
         <div className={`flex flex-col ${hasBorder ? "gap-6" : "gap-10"}`}>

         <header className={` flex w-full items-center justify-between pt-[26px] pb-0 px-4 ${CustomClass} `}>
            {
              hasBackBtn ? <button onClick={handleClose}>
                <ChevronLeft className="w-6 h-6 rtl:scale-[-1]" color='#003d6b' />
              </button>
                : <button onClick={handleClose}>
                  <CloseIcon size="sm" className='text-[#003d6b]' />
                </button>
            }

            {title && <h1 className="font-normal text-[#003d6b] text-base">
              {title}
            </h1>}

            {hasMenu ? <button onClick={handleOpenMenu} >
              <MenuIcon color="#003d6b" />
            </button> :
              <>
                {!hasClearBtn && !hasApplyBtn && <span></span>}
              </>}
            {
              hasClearBtn && <button onClick={handleClear} className='text-secondary text-sm leading-6 font-normal'>{t('Clear')}</button>
            }

            {
              hasApplyBtn && <button onClick={handleApply} className='text-secondary text-sm leading-6 font-medium'>{t('Apply')}</button>
            }
          </header>
          {
            hasBorder && <Divider className="!border-[#E7F0F9] border-2    font-normal w-full" />

          }
         </div>

          {
            subTitle &&
            <p className="font-normal text-gray-400 text-xs leading-6 text-center px-4">
              {subTitle}
            </p>
          }

        </div>
        {children}
      </div>


    </Dialog>

  );
};



export default FullScreenDialog;
